
export enum Role {
  ADMIN = 'ROLE_ADMIN',
  SUPERADMIN = 'ROLE_SUPERADMIN',

  CONSUMER = 'ROLE_CONSUMER',
  EXTERNAL_BROKER = 'ROLE_EXTERNAL_BROKER',
  RES_ASSOCIATE_BROKER = 'ROLE_RES_ASSOCIATE_BROKER',
  RES_INTERNAL_BROKER = 'ROLE_RES_INTERNAL_BROKER',

  SALES_LEASING_EXECUTIVE = 'ROLE_SALES_LEASING_EXECUTIVE',

  SD_MANAGER = 'ROLE_SD_MANAGER',
  SALES_DIRECTOR = 'ROLE_SALES_DIRECTOR',
  EXTERNAL_SALES_DIRECTOR = 'ROLE_EXTERNAL_SALES_DIRECTOR',
  BROKER_COORDINATOR = 'ROLE_BROKER_COORDINATOR',
  PARTNER_BROKER = 'ROLE_PARTNER_BROKER',

  CONTENT_PROVIDER = 'ROLE_CONTENT_PROVIDER',
  LISTINGS = 'ROLE_LISTINGS',
  MARKETING = 'ROLE_MARKETING',
  BROKER_MANAGER = 'ROLE_BROKER_MANAGER',
  COM_ASSOCIATE_BROKER = 'ROLE_COM_ASSOCIATE_BROKER',
  COM_INTERNAL_BROKER = 'ROLE_COM_INTERNAL_BROKER',
  SALES_SUPPORT = 'ROLE_SALES_SUPPORT',
  ACCOUNT_MANAGER = 'ROLE_ACCOUNT_MANAGER',
  ACCOUNTING = 'ROLE_ACCOUNTING',
  LISTING_APPROVAL_SUPPORT = 'ROLE_LISTING_APPROVAL_SUPPORT',
  LISTING_APPROVER = 'ROLE_LISTING_APPROVER',
}
